<template>
  <AppDialog :is-open="isDialogOpened"
             :ok-disabled="changeSignerPending || selectedMembers.length === 0"
             :ok-loading="changeSignerPending"
             :ok-text="$t('common.change')"
             size="l"
             :cancel-disabled="changeSignerPending"
             @cancel="closeDialog"
             @ok="prepareChangeSigner"
  >
    <template #title>
      {{
        isSignerWitness
          ? $t('project.signing-checklist.prepare-signature.PrepareSignatureChangeSignerDialog.modifyWitness')
          : $t('project.signing-checklist.prepare-signature.PrepareSignatureChangeSignerDialog.modifySignatory')
      }}
    </template>
    <template #body>
      <template v-if="!componentLoading">
        <v-row>
          <v-col>
            <p class="text--medium">
              {{ $t('project.signing-checklist.prepare-signature.PrepareSignatureChangeSignerDialog.selectSignatory', { name: signer.fullName }) }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <DocumentSharePicker
              :force-pm-selection="false"
              :multi-select="false"
              users-only
            />
          </v-col>
        </v-row>
      </template>
    </template>
  </AppDialog>
</template>

<script>
import { defineComponent } from 'vue'
import { mapActions, mapGetters, mapState } from 'vuex'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import DocumentSharePicker from '@/common/document-share/DocumentSharePicker.vue'
import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'
import { DocumentSharePickerActionTypes } from '@/store/modules/document-share-picker/action_types'
import { CHANGE_SIGNER } from '@/store/modules/prepareSignature/action_types'

export default defineComponent({
  name: 'PrepareSignatureChangeSignerDialog',
  components: {
    AppDialog,
    DocumentSharePicker,
  },
  props: {
    signer: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      componentLoading: false,
    }
  },
  computed: {
    ...mapState('prepareSignature', ['changeSignerPending', 'taggingInformation', 'envelopeDisplayInformation']),
    ...mapState('documentSharePicker', ['selectedMembers']),
    ...mapState('groups', ['groups']),
    ...mapGetters('room', ['roomMnemo']),
    isSignerWitness () {
      return this.signer.signatureType === 'witness'
    },
  },
  mounted () {
    this.onOpen()
  },
  mixins: [dialogMixin],
  methods: {
    ...mapActions('groups', ['GET_GROUPS']),
    ...mapActions('documentSharePicker', [DocumentSharePickerActionTypes.DISABLE_MEMBERS]),
    ...mapActions('prepareSignature', [CHANGE_SIGNER]),
    isMemberSelected (memberId) {
      return this.taggingInformation.signers.find(signersGroup => signersGroup.some(signer => signer.signerId === memberId))
    },
    async onOpen () {
      this.componentLoading = true
      try {
        this.openDialog = true
        await this.GET_GROUPS(this.roomMnemo)

        const membersToDisable = this.groups.flatMap(group => group.members)
          .filter(member => this.isMemberSelected(member.id))

        if (membersToDisable.length) {
          this.DISABLE_MEMBERS(membersToDisable)
        }
      } finally {
        this.componentLoading = false
      }
    },
    async prepareChangeSigner () {
      try {
        await this.CHANGE_SIGNER({
          mnemo: this.roomMnemo,
          envId: this.envelopeDisplayInformation.envelopeId,
          oldUserId: this.signer.signerId,
          data: {
            newSigner: this.selectedMembers[0].id,
          },
        })

        toast.success(this.$t('project.signing-checklist.prepare-signature.PrepareSignatureChangeSignerDialog.changeSigner.successText'))
        this.$emit('update-signers-list')
      } catch (error) {
        console.error(error)
        toast.error(this.$t('project.signing-checklist.prepare-signature.PrepareSignatureChangeSignerDialog.changeSigner.errorText'))
      } finally {
        this.closeDialog()
      }
    },
  },
})
</script>
